import React, { FC, useMemo } from 'react'
import { compose } from 'redux'
import { Field, FormErrors, InjectedFormProps, reduxForm } from 'redux-form'
import { ConfigProps } from 'redux-form/lib/reduxForm'
import { Grid, Typography, withStyles } from '@material-ui/core'
import { getStyles } from 'isotope-client'
import { FormattedMessage, useIntl } from 'react-intl'
import Input from '../../../../components/form/Input'
import Radio from '../../../../components/form/Radio'
import { FORM_FIELDS, MESSAGE_BASE, REQUIRED_FIELDS } from '../services/competence.consts'
import { TYPE_COMPETENCE } from '../services/competence.enums'
import { CompetenceFormValues } from '../services/competence.types'

/**
 * Styles
 */
const styles = () => getStyles({
	field: {
		width: '100%'
	},
	row: {
		marginBottom: 15
	},
	radioLabel: {
		fontSize: 13,
		color: '#000',
		paddingLeft: 10,
		marginBottom: 5
	}
})

type CompetenceFormOwnProps = {
	// en édition, le type de compétence est affiché mais non modifiable
	isEdition?: boolean
}

type CompetenceFormProps = CompetenceFormOwnProps & {
	classes: ClassNameMap
}

const validate = (values: CompetenceFormValues): FormErrors<CompetenceFormValues> => {
	const errors: FormErrors<CompetenceFormValues> = {}
	REQUIRED_FIELDS.forEach(field => {
		if (!values[field as keyof CompetenceFormValues]) {
			errors[field as keyof CompetenceFormValues] = <FormattedMessage id="global.errors.mandatory" />
		}
	})
	return errors
}

const CompetenceForm: FC<CompetenceFormProps & InjectedFormProps<CompetenceFormValues>> = ({ isEdition, classes, handleSubmit }) => {
	const intl = useIntl()

	const typeChoices = useMemo(() => Object.values(TYPE_COMPETENCE).map(type => ({
		value: type,
		label: intl.formatMessage({ id: `${MESSAGE_BASE}.form.fields.${FORM_FIELDS.TYPE_COMPETENCE}.values.${type}` })
	})), [intl])

	return (
		<form onSubmit={handleSubmit}>
			<Grid container className={classes.row}>
				<Grid item className={classes.field}>
					<Typography className={classes.radioLabel}>
						<FormattedMessage id={`${MESSAGE_BASE}.form.fields.${FORM_FIELDS.TYPE_COMPETENCE}.label`} />
					</Typography>
					<Field
						name={FORM_FIELDS.TYPE_COMPETENCE}
						component={Radio}
						choices={typeChoices}
						disabled={isEdition}
						row
					/>
				</Grid>
				<Grid item className={classes.field}>
					<Field
						name={FORM_FIELDS.NOM}
						component={Input}
						label={<FormattedMessage id={`${MESSAGE_BASE}.form.fields.${FORM_FIELDS.NOM}`} />}
						reverseBackground
					/>
				</Grid>
				<Grid item className={classes.field}>
					<Field
						name={FORM_FIELDS.DESCRIPTION}
						component={Input}
						label={<FormattedMessage id={`${MESSAGE_BASE}.form.fields.${FORM_FIELDS.DESCRIPTION}`} />}
						reverseBackground
					/>
				</Grid>
			</Grid>
		</form>
	)
}

export default compose<FC<ConfigProps<CompetenceFormValues> & CompetenceFormOwnProps>>(
	reduxForm({
		enableReinitialize: true,
		validate
	}),
	withStyles(styles)
)(CompetenceForm)
